
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
import textjgpl from '~/components/textTrader/_jianGuanPiLou.vue'
import wikiTextScroll from '~/components/common/wikiTextScroll.vue'
export default {
  components: {
    'text-title': textTraderTitle,
    'wiki-text-scroll': wikiTextScroll,
    'text-textjgpl': textjgpl
  },
  inject: ['info'],
  data() {
    const _lineheight = []
    if (this.info && this.info.safety && this.info.safety.regulators && this.info.safety.regulators.length > 0) {
      this.info.safety.regulators.forEach((item, k) => {
        _lineheight.push('auto')
      })
      _lineheight.push('auto')
    }
    return {
      showall: false,
      lineheight: _lineheight,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'safe' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('安全', this.info?.safety)
  },
  methods: {
    show(mark) {
      this.showall = mark
      if (mark) {
        const that = this
        setTimeout(function () {
          that.DealLineHeight()
          that.$forceUpdate()
        }, 300)
      }
    },
    GetRegularName(item) {
      if (!item) {
        return '--'
      }
      const contry = item.CountryName
      const shortName = item.ShortName
      const fullname = item.FullName
      if (contry && shortName && shortName.includes(contry)) {
        return fullname + '(' + shortName.replace(contry, '').replace(' ', '') + ')'
      } else if (shortName) {
        return fullname + '(' + shortName + ')'
      } else {
        return fullname
      }
    },
    DealLineHeight() {
      if (this.lineheight && this.lineheight.length > 0) {
        this.lineheight.forEach((item, k) => {
          const line = this.GetLineHeightByClass('safe_tbline' + k) + 'px'
          this.lineheight[k] = line
        })
      }
    },
    GetLineHeightByClass(cls) {
      const objlist = document.querySelectorAll('.' + cls)
      let hg = 22
      if (objlist && objlist.length > 0) {
        objlist.forEach((item, k) => {
          const height = item.getBoundingClientRect().height
          if (height > hg) {
            hg = height
          }
        })
      }
      return hg
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
